import React from 'react'

const Font = () => {
  return (
    <div>Font</div>
  )
}

export default Font